function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
/**
 * Canonical UTXO location helpers for RustScript publish / unlock artifacts.
 *
 * Saito utxoset keys include block_id, tx_ordinal, and slip_index. Publish txs
 * start with zeros on outputs; those fields are assigned when the block is
 * generated. Export / P2SH-link flows must carry the confirmed values.
 */

function toBigIntOrNull(value) {
  if (value === undefined || value === null || value === '') {
    return null;
  }
  try {
    return BigInt(value);
  } catch (_err) {
    return null;
  }
}
function slipBlockId(slip) {
  var _slip$blockId;
  return toBigIntOrNull((_slip$blockId = slip === null || slip === void 0 ? void 0 : slip.blockId) !== null && _slip$blockId !== void 0 ? _slip$blockId : slip === null || slip === void 0 ? void 0 : slip.block_id);
}
function slipTxOrdinal(slip) {
  var _slip$txOrdinal;
  return toBigIntOrNull((_slip$txOrdinal = slip === null || slip === void 0 ? void 0 : slip.txOrdinal) !== null && _slip$txOrdinal !== void 0 ? _slip$txOrdinal : slip === null || slip === void 0 ? void 0 : slip.tx_ordinal);
}
function outputsMissingCanonicalLocation(tx) {
  var outputs = Array.isArray(tx === null || tx === void 0 ? void 0 : tx.to) ? tx.to : [];
  if (!outputs.length) {
    return true;
  }
  return outputs.some(function (slip) {
    var blockId = slipBlockId(slip);
    var txOrdinal = slipTxOrdinal(slip);
    return blockId == null || blockId === 0n || txOrdinal == null;
  });
}

/**
 * Read block_id / tx_ordinal from a confirmation block + tx, or from slips.
 */
function readTransactionLocation(tx) {
  var blk = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var blockId = null;
  var txOrdinal = null;
  if (blk != null) {
    var _blk$id;
    blockId = toBigIntOrNull((_blk$id = blk.id) !== null && _blk$id !== void 0 ? _blk$id : blk.block_id);
    var txs = Array.isArray(blk.transactions) ? blk.transactions : [];
    if (tx !== null && tx !== void 0 && tx.signature) {
      var idx = txs.findIndex(function (candidate) {
        return (candidate === null || candidate === void 0 ? void 0 : candidate.signature) === tx.signature;
      });
      if (idx >= 0) {
        txOrdinal = BigInt(idx);
      }
    }
  }
  if ((blockId == null || blockId === 0n) && Array.isArray(tx === null || tx === void 0 ? void 0 : tx.to)) {
    var _iterator = _createForOfIteratorHelper(tx.to),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var slip = _step.value;
        var bid = slipBlockId(slip);
        if (bid != null && bid !== 0n) {
          blockId = bid;
          break;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  if (txOrdinal == null && Array.isArray(tx === null || tx === void 0 ? void 0 : tx.to)) {
    var _iterator2 = _createForOfIteratorHelper(tx.to),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _slip = _step2.value;
        var ord = slipTxOrdinal(_slip);
        if (ord != null) {
          txOrdinal = ord;
          break;
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  return {
    blockId: blockId,
    txOrdinal: txOrdinal,
    transactionId: tx !== null && tx !== void 0 && tx.signature ? String(tx.signature) : ''
  };
}

/**
 * Stamp output slips with canonical block_id / tx_ordinal / slip_index.
 * Input slips are left unchanged (they already reference prior UTXOs).
 */
function stampOutputSlipLocations(tx) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    blockId = _ref.blockId,
    txOrdinal = _ref.txOrdinal;
  if (!tx) {
    throw new Error('Transaction is required');
  }
  var resolvedBlockId = toBigIntOrNull(blockId);
  var resolvedTxOrdinal = toBigIntOrNull(txOrdinal);
  if (resolvedBlockId == null || resolvedBlockId === 0n) {
    throw new Error('Confirmed block_id is required to stamp transaction outputs');
  }
  if (resolvedTxOrdinal == null) {
    throw new Error('Confirmed transaction ordinal is required to stamp transaction outputs');
  }
  var outputs = Array.isArray(tx.to) ? tx.to : [];
  for (var i = 0; i < outputs.length; i++) {
    var slip = outputs[i];
    if (!slip) {
      continue;
    }
    slip.blockId = resolvedBlockId;
    slip.txOrdinal = resolvedTxOrdinal;
    slip.index = i;
  }
  return tx;
}

/**
 * Ensure publish-tx outputs carry canonical location before export / unlock use.
 * Prefers explicit hints, then values already on the tx, then confirmation block.
 */
function ensureCanonicalOutputLocations(tx) {
  var _toBigIntOrNull, _toBigIntOrNull2;
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref2$blockId = _ref2.blockId,
    blockId = _ref2$blockId === void 0 ? null : _ref2$blockId,
    _ref2$txOrdinal = _ref2.txOrdinal,
    txOrdinal = _ref2$txOrdinal === void 0 ? null : _ref2$txOrdinal,
    _ref2$blk = _ref2.blk,
    blk = _ref2$blk === void 0 ? null : _ref2$blk;
  if (!tx) {
    throw new Error('Transaction is required');
  }
  var fromBlock = readTransactionLocation(tx, blk);
  var resolvedBlockId = (_toBigIntOrNull = toBigIntOrNull(blockId)) !== null && _toBigIntOrNull !== void 0 ? _toBigIntOrNull : fromBlock.blockId;
  var resolvedTxOrdinal = (_toBigIntOrNull2 = toBigIntOrNull(txOrdinal)) !== null && _toBigIntOrNull2 !== void 0 ? _toBigIntOrNull2 : fromBlock.txOrdinal;
  if (!outputsMissingCanonicalLocation(tx)) {
    return {
      tx: tx,
      blockId: slipBlockId(tx.to[0]),
      txOrdinal: slipTxOrdinal(tx.to[0]),
      stamped: false
    };
  }
  stampOutputSlipLocations(tx, {
    blockId: resolvedBlockId,
    txOrdinal: resolvedTxOrdinal
  });
  return {
    tx: tx,
    blockId: resolvedBlockId,
    txOrdinal: resolvedTxOrdinal,
    stamped: true
  };
}
function parseP2shShareLink(raw) {
  var text = String(raw || '').trim();
  if (!text) {
    throw new Error('P2SH link is empty.');
  }
  var url;
  try {
    url = new URL(text);
  } catch (_err) {
    // Allow paste of query-only fragments: ?block_id=1&transaction_id=...
    try {
      url = new URL(text, 'https://p2sh.local/');
    } catch (_err2) {
      throw new Error('P2SH link is not a valid URL.');
    }
  }
  var params = url.searchParams;
  var blockId = params.get('block_id') || params.get('blockId') || '';
  var transactionId = params.get('transaction_id') || params.get('transactionId') || params.get('signature') || '';
  var scripthash = params.get('scripthash') || '';
  var p2shAddress = params.get('p2sh_address') || params.get('p2shAddress') || '';
  if (!blockId) {
    throw new Error('P2SH link is missing block_id.');
  }
  if (!transactionId) {
    throw new Error('P2SH link is missing transaction_id.');
  }
  return {
    blockId: String(blockId),
    transactionId: String(transactionId),
    scripthash: String(scripthash),
    p2shAddress: String(p2shAddress)
  };
}
function loadBlockById(_x, _x2) {
  return _loadBlockById.apply(this, arguments);
}
/**
 * Fetch the confirmed publish transaction referenced by a P2SH link and ensure
 * output slips carry canonical location fields.
 */
function _loadBlockById() {
  _loadBlockById = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(app, blockId) {
    var id, blockchain, hash, block, txs, looksSpv, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          id = toBigIntOrNull(blockId);
          if (!(id == null || id === 0n)) {
            _context.n = 1;
            break;
          }
          throw new Error('Invalid block_id.');
        case 1:
          blockchain = app === null || app === void 0 ? void 0 : app.blockchain;
          if (blockchain) {
            _context.n = 2;
            break;
          }
          throw new Error('Blockchain is unavailable.');
        case 2:
          hash = '';
          if (!(typeof blockchain.getLongestChainHashAtId === 'function')) {
            _context.n = 4;
            break;
          }
          _context.n = 3;
          return blockchain.getLongestChainHashAtId(id);
        case 3:
          hash = _context.v;
        case 4:
          block = null;
          if (!(hash && typeof blockchain.loadBlockAsync === 'function')) {
            _context.n = 6;
            break;
          }
          _context.n = 5;
          return blockchain.loadBlockAsync(String(hash));
        case 5:
          block = _context.v;
        case 6:
          if (!(!block && hash && typeof blockchain.getBlock === 'function')) {
            _context.n = 8;
            break;
          }
          _context.n = 7;
          return blockchain.getBlock(String(hash), true);
        case 7:
          block = _context.v;
        case 8:
          if (!(!block && typeof blockchain.getBlock === 'function')) {
            _context.n = 12;
            break;
          }
          _context.p = 9;
          _context.n = 10;
          return blockchain.getBlock(id, true);
        case 10:
          block = _context.v;
          _context.n = 12;
          break;
        case 11:
          _context.p = 11;
          _t = _context.v;
        case 12:
          if (block) {
            _context.n = 13;
            break;
          }
          throw new Error("Could not load block ".concat(id.toString(), "."));
        case 13:
          txs = Array.isArray(block.transactions) ? block.transactions : [];
          looksSpv = txs.length > 0 && txs.every(function (tx) {
            return !(tx !== null && tx !== void 0 && tx.signature);
          });
          if (!(!txs.length || looksSpv)) {
            _context.n = 14;
            break;
          }
          throw new Error("Block ".concat(id.toString(), " does not include full transactions on this node. Try again from a peer that has the block body."));
        case 14:
          return _context.a(2, block);
      }
    }, _callee, null, [[9, 11]]);
  }));
  return _loadBlockById.apply(this, arguments);
}
function fetchTransactionFromP2shLink(_x3, _x4) {
  return _fetchTransactionFromP2shLink.apply(this, arguments);
}
function _fetchTransactionFromP2shLink() {
  _fetchTransactionFromP2shLink = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(app, linkFields) {
    var _block$id;
    var blockId, transactionId, block, txs, index, tx;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          blockId = linkFields === null || linkFields === void 0 ? void 0 : linkFields.blockId;
          transactionId = String((linkFields === null || linkFields === void 0 ? void 0 : linkFields.transactionId) || '');
          if (transactionId) {
            _context2.n = 1;
            break;
          }
          throw new Error('transaction_id is required.');
        case 1:
          _context2.n = 2;
          return loadBlockById(app, blockId);
        case 2:
          block = _context2.v;
          txs = Array.isArray(block.transactions) ? block.transactions : [];
          index = txs.findIndex(function (tx) {
            return String((tx === null || tx === void 0 ? void 0 : tx.signature) || '') === transactionId;
          });
          if (!(index < 0)) {
            _context2.n = 3;
            break;
          }
          throw new Error('Transaction was not found in the referenced block.');
        case 3:
          tx = txs[index];
          ensureCanonicalOutputLocations(tx, {
            blockId: (_block$id = block.id) !== null && _block$id !== void 0 ? _block$id : blockId,
            txOrdinal: index,
            blk: block
          });
          return _context2.a(2, tx);
      }
    }, _callee2);
  }));
  return _fetchTransactionFromP2shLink.apply(this, arguments);
}
module.exports = {
  toBigIntOrNull: toBigIntOrNull,
  outputsMissingCanonicalLocation: outputsMissingCanonicalLocation,
  readTransactionLocation: readTransactionLocation,
  stampOutputSlipLocations: stampOutputSlipLocations,
  ensureCanonicalOutputLocations: ensureCanonicalOutputLocations,
  parseP2shShareLink: parseP2shShareLink,
  fetchTransactionFromP2shLink: fetchTransactionFromP2shLink
};